<template>
  <v-row no-gutters>
    <v-col cols="12" md="12">
      <v-toolbar dark color="primary pl-2 pr-2" density="compact">
        <v-toolbar-title>Photo
          <v-icon class="ml-5" @click="downloadPhoto()">mdi-arrow-down-box</v-icon>
          <v-icon class="ml-3" @click="clickRotate()" v-if="false">mdi-rotate-3d-variant</v-icon>
          <v-icon class="ml-3" @click="clickDelete()" v-if="false">mdi-delete-forever</v-icon>
        </v-toolbar-title>
        
        <!-- <v-spacer></v-spacer> -->
        <v-btn icon dark @click="$emit('closeDialog')">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-toolbar>
    </v-col>
    <v-col cols="1" md="1">
      <center>
        <v-btn v-if="showPre" variant="outlined" density="compact" class="mt-7" color="black" icon @click="clickPreMethod()">
          <v-icon color="black" size="small">mdi-chevron-left</v-icon>
        </v-btn>
      </center>
    </v-col>
    <v-col cols="10" md="10" class="mt-2">
      <v-img
      class="rotatedNormal" v-if="rotateIndex==1"
        aspect-ratio="4/3"
        cover
        :src="srcMethodSendPhoto(message)"
      ></v-img>
      <!-- <v-img
      class="rotated90" v-if="rotateIndex==2"
        aspect-ratio="4/3"
        cover
        :src="srcMethodSendPhoto(message)"
      ></v-img>
      <v-img
      class="rotated180" v-if="rotateIndex==3"
        aspect-ratio="4/3"
        cover
        :src="srcMethodSendPhoto(message)"
      ></v-img>
      <v-img
      class="rotated270" v-if="rotateIndex==4"
        aspect-ratio="4/3"
        cover
        :src="srcMethodSendPhoto(message)"
      ></v-img> -->
    </v-col>
    <v-col cols="1" md="1">
      <center>
        <v-btn v-if="showNext" variant="outlined" density="compact" class="mt-7" color="black" icon @click="clickNextMethod()">
          <v-icon color="black" size="small">mdi-chevron-right</v-icon>
        </v-btn>
      </center>
    </v-col>
    <v-col>
      <v-dialog v-model="dialogDelete" width="500">
        <v-card>
          <v-card-title class="text-h5 white--text bg-red"> Delete </v-card-title>

          <v-card-text class="text-h6 ">
            Are you sure to delete?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogDelete = false">
              CANCEL
            </v-btn>
            <v-btn  class="bg-red" text @click="clickDeleteDialog()">
              DELETE
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import axios from "../config";
import messageService from "../service/MessageService";
import friService from "../service/FriendService";
export default {
  data: () => ({
    rotateIndex:1,
    dialogDelete:false,
    message:{},
    showNext:true,
    showPre:true,
    customerId:0,
  }),
  props: { refreshMessage: Number, messagePhoto: Object },
  mounted: function () {
    this.message = Object.assign({},this.messagePhoto);
    this.customerId = this.message.customerId;
  },
  methods: {
    clickNextMethod:function(){
      if(this.message.messageId!=undefined){
        messageService
          .getMessageNextPre(this.message.messageId, this.message.pageId,"next",this.customerId)
          .then((response) => {
            if(response.messageId>0){
            this.message = Object.assign({},response);
            this.showPre = true;
            }else{
              this.showNext = false;
            }
          })
          .catch((error) => {
            this.$swal("Fail!", error.response.data.message, "error");
          });
      }else{
        friService
          .getFriendMessageNextPre(this.message.privateMessageId, this.message.requestFormId,"next")
          .then((response) => {
            if(response.privateMessageId>0){
            this.message = Object.assign({},response);
            this.showPre = true;
            }else{
              this.showNext = false;
            }
          })
          .catch((error) => {
            this.$swal("Fail!", error.response.data.message, "error");
          });
      }
      
    },
    clickPreMethod:function(){
      if(this.message.messageId!=undefined){
        messageService
          .getMessageNextPre(this.message.messageId, this.message.pageId,"pre",this.customerId)
          .then((response) => {
            if(response.messageId>0){
            this.message = Object.assign({},response);
            this.showNext = true;
          }else{
              this.showPre = false;
            }
          })
          .catch((error) => {
            this.$swal("Fail!", error.response.data.message, "error");
          });
      }else{
        friService
        .getFriendMessageNextPre(this.message.privateMessageId, this.message.requestFormId,"pre")
          .then((response) => {
            if(response.privateMessageId>0){
            this.message = Object.assign({},response);
            this.showNext = true;
          }else{
              this.showPre = false;
            }
          })
          .catch((error) => {
            this.$swal("Fail!", error.response.data.message, "error");
          });
      }
      
    },
    clickDelete:function(){
      this.dialogDelete = true;
    },
    clickDeleteDialog:function(){
      this.dialogDelete = false;
      messageService
          .deleteMessage(this.message, this.message.pageId)
          .then((response) => {
            this.clickPreMethod();
          })
          .catch((error) => {
            this.$swal("Fail!", error.response.data.message, "error");
          });
    },
    clickRotate:function(){
        this.rotateIndex = Number(this.rotateIndex)+1;
        if(this.rotateIndex==5){
          this.rotateIndex = 1;
        }
    },
    downloadPhoto:function(){
      let photo = this.message.sendPhoto+this.message.messageId+`.png`;
      if(this.message.messageId==undefined){//requestFormId
        photo = this.message.sendPhoto + this.message.privateMessageId+`.png`;
      }
      let url =  this.srcMethodSendPhoto(this.message);
      axios({
          method: 'get',
          url,
          responseType: 'arraybuffer',
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', photo)
        document.body.appendChild(link)
        link.click()
          })
          .catch(() => console.log('error occured'))
    },
    srcMethodSendPhoto: function (message) {
      let photo = message.sendPhoto + message.messageId;
      if(message.messageId==undefined){//requestFormId
        photo = message.sendPhoto + message.privateMessageId;
      }
      
      return `${axios.defaults.baseURL}/photo/${photo}.png`;
    },
  },
  watch: {
    refreshMessage() {
      this.message = Object.assign({},this.messagePhoto);
      this.customerId = this.message.customerId;
      this.srcMethodSendPhoto(this.message);
    },
  },
  components: {},
};
</script>
<style scoped>
.rotatedNormal {
  transform: rotate(0); 
  background-color: pink;
}
/* .rotated90 {
  transform: rotate(90deg); 
  background-color: pink;
}
.rotated180 {
  transform: rotate(3.142rad); 
  background-color: pink;
}
.rotated270 {
  transform: rotate(-0.25turn); 
  background-color: pink;
} */
</style>